import { RicosViewer } from '@wix/ricos/viewer';
import '@wix/ricos/css/ricos-viewer.global.css';

export default RicosViewer;
